import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-flow-col auto-cols-max mx-auto gap-4 justify-center lg:gap-11 md:grid-cols-[repeat(3,198px)]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-center txt__notoSB20 !mb-4" }, "タップでリアクションを送る", -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reactionButtons, (button) => {
        return (_openBlock(), _createBlock($setup["VueReactionButton"], {
          type: button.type,
          key: button.type,
          icon: button.icon,
          label: button.label,
          count: $setup.reactionData?.counts?.[button.type] ?? 0,
          active: $setup.reactionData?.my_reaction_type === button.type,
          disabled: $setup.isSubmitting,
          onClickReaction: $setup.toggleReaction
        }, null, 8 /* PROPS */, ["type", "icon", "label", "count", "active", "disabled"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 64 /* STABLE_FRAGMENT */))
}